import { showRequestError } from '../../utils/request-feedback';
import { useEffect, useState } from 'react'
import { exportUsersQuiz, fetchProfilingQuiz } from '../../api/community';
import { Space, Button, Table, Pagination, Flex, Tag } from 'antd';
import { useDebouncedCallback } from 'use-debounce';
import UserInfoView from '../../components/community/user_info_view';
import dayjs from 'dayjs';
import { Typography } from 'antd';
import { exportCsv } from '../../utils/comm';

const InvestQuizView = () => {
    const [tabData, setTabData] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [keyword, setKeyword] = useState();

    const tabCols = [
        {
            title: 'Index',
            dataIndex: 'id',
            key: 'id',
            render: (text, _, index) => ((pageNum - 1) * pageSize + index + 1),
            fixed: 'left',
        },
        {
            title: 'User',
            dataIndex: 'user',
            key: 'user',
            render: (text, _) => {
                if (!text) return ''
                return <UserInfoView user={text} showWallet={false} />
            },
            fixed: 'left',
        },
        {
            title: 'Interested Tickers',
            dataIndex: 'interestedTickers',
            key: 'interestedTickers',
            render: (_, record) => {
                let {aiInterestStatus, aiInterest} = record;
                try {
                    if(aiInterestStatus === 2){
                      let tickersInfo = JSON.parse(aiInterest);
                      return <Space wrap size={[0, 4]}>
                        {
                            Array.from(tickersInfo['tickers'] || []).map((item, index) => {
                                return <Tag style={{ fontSize: 11 }} key={index} mark><strong>{item.ticker}</strong> {item.weight}</Tag>
                            })
                        }
                    </Space>;
                }
                } catch (error) {
                    return '';
                }
                
                return ''
            },
            fixed: 'left',
        },
        {
            title: 'How is your investment knowledge?',
            dataIndex: 'answer1',
            key: 'answer1',
            render: (_, record) => {
                return <div style={{ fontSize: 11, width: 160 }}>{record.investmentAnswer[0].val}</div>;
            },
        },
        {
            title: 'Which industry interests you for investment?',
            dataIndex: 'answer2',
            key: 'answer2',
            render: (_, record) => {
                let quiz = record.investmentAnswer.filter(item => item.name === 'Which are you interested in?' || item.name === 'Which industry interests you for investment?')[0];
                if (quiz) {
                    let ans = quiz.val;
                    if (Array.isArray(ans)) {
                        return <Space size={[4, 0]} wrap style={{ width: 160 }}>
                            {ans.map((item, index) => <Typography.Text style={{ fontSize: 11 }} key={index} mark>{item}</Typography.Text>)}
                        </Space>
                    }
                    return ans;
                }
                return '-'
            },
        },
        {
            title: 'Which companies are you considering for your portfolio?',
            dataIndex: 'answer3',
            key: 'answer3',
            render: (_, record) => {
                let quiz = record.investmentAnswer.filter(item => item.name === 'Which companies are you interested in?' || item.name === 'Which companies are you considering for your portfolio?')[0];
                if (quiz) {
                    let ans = quiz.val;
                    if (Array.isArray(ans)) {
                        return <Space size={[4, 0]} wrap style={{ width: 160 }}>
                            {ans.map((item, index) => <Typography.Text style={{ fontSize: 11 }} key={index} mark>{item}</Typography.Text>)}
                        </Space>
                    }
                    return ans;
                }
                return '-'
            },
        },
        {
            title: 'Created',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            render: (text, _) => {
                if (!text) return ''
                return <label style={{ fontSize: 12, color: '#afafaf', whiteSpace: 'nowrap' }}>{dayjs(text).format('MM-DD HH:mm')}</label>
            },
        },
    ];

    useEffect(() => {
        getQuizs(pageNum, pageSize, keyword);
    }, [])

    const getQuizs = useDebouncedCallback(
        (pNum, pSize, search) => {
            let params = {
                'page.num': pNum,
                'page.size': pSize,
                'category': 1,
            }
            setLoading(true);
            fetchProfilingQuiz(params).then(res => {
                if (res.list) {
                    setTabData(res.list.map(item => {
                        return { ...item, investmentAnswer: JSON.parse(item.investmentAnswer) }
                    }));
                }
                if (res.page) {
                    setTotal(res.page.total);
                }
            }).finally(() => setLoading(false)).catch(showRequestError)
        },
        300)

    const pageChange = (page, size) => {
        setPageNum(page);
        setPageSize(size);
        getQuizs(page, size, keyword);
    }

    const onSearchChange = (value) => {
        setKeyword(value);
        setPageNum(1);
        getQuizs(1, pageSize, value);
    }

    const exportHandle = () => {
        let params = {
            'size': total,
            'questionName': 'Have you ever invested in financial products?',
            'questionVal': keyword
        }
        setLoading(true);
        exportUsersQuiz(params).then(res => {
            if (res) {
                exportCsv(res, '问卷调查数据');
            }
        }).finally(() => setLoading(false)).catch(showRequestError)
    }

    return (
        <div className='main-wrapper'>
            {/* <div className='top-part cnt-item'>

                <Flex justify='space-between'>
                    <Space>
                        <Button type='primary' onClick={exportHandle} icon={<ExportOutlined />}>Export</Button>
                    </Space>
                    <Select
                        style={{ width: 420 }}
                        options={[
                            { label: 'Yes, I have investment experience', value: 'Yes, I have investment experience', key: 1 },
                            { label: 'No, I am a beginner', value: 'No, I am a beginner', key: 2 }
                        ]}
                        placeholder='Have you ever invested in financial products?'
                        onChange={value => onSearchChange(value)}
                        allowClear
                    />
                </Flex>
            </div> */}
            <div className='cnt-item'>
                <Table
                    scroll={{ x: true }}
                    loading={loading}
                    rowKey={(record) => record.id}
                    rowClassName={'table-row'}
                    size='small'
                    dataSource={tabData}
                    columns={tabCols}
                    pagination={false} />
            </div>
            <div className='footer-part cnt-item'>
                <Pagination
                    total={total}
                    showTotal={(total) => `total ${total}`}
                    current={pageNum}
                    pageSize={pageSize}
                    showSizeChanger={true}
                    pageSizeOptions={[10, 20, 30, 50]}
                    onChange={(page, size) => pageChange(page, size)}
                />
            </div>
        </div>
    )
}

export default InvestQuizView;